import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ privacyPolicyId = '', ...params }) => {
  return await dponetAPI.get(`/privacy_policies/${privacyPolicyId}`, { params })
}

const create = async ({ ...data }) => {
  return await dponetAPI.postForm('/privacy_policies', { privacyPolicy: data })
}

const put = async ({ privacyPolicyId = '', ...data }) => {
  return await dponetAPI.putForm(`/privacy_policies/${privacyPolicyId}`, {
    privacyPolicy: data,
  })
}

const destroy = async ({ privacyPolicyId = '' }) => {
  return await dponetAPI.delete(`/privacy_policies/${privacyPolicyId}`)
}

const exportDocument = async ({ privacyPolicyId = '' }) => {
  return await dponetAPI.get(`/privacy_policies/${privacyPolicyId}/export`)
}

const listVersions = async ({ privacyPolicyId = '', ...params }) => {
  return await dponetAPI.get(`/privacy_policies/${privacyPolicyId}/versions`, {
    params,
  })
}

const certificate = async ({ token = '' }) => {
  return await dponetAPI.get(`/privacy_policies/${token}/certificate`)
}

const createCookiePolicy = async () =>
  await dponetAPI.post('/privacy_policies/cookies_policy')

const updateCookiePolicy = async ({ cookiePolicyId }) =>
  await dponetAPI.put(`/privacy_policies/${cookiePolicyId}/cookies_policy`)

const getCookiePolicy = async () => {
  return await dponetAPI.get('/privacy_policies', {
    params: {
      category: 'cookie_policy',
      showContent: true,
    },
  })
}

const updatePrivacyPermissions = async ({ privacyPolicyId = '', ...data }) => {
  return await dponetAPI.put(
    `/privacy_policies/${privacyPolicyId}/privacy_permissions`,
    {
      privacyPermission: data,
    },
  )
}

const getPrivacyPermissions = async ({ privacyPolicyId = '' }) => {
  return await dponetAPI.get(
    `/privacy_policies/${privacyPolicyId}/privacy_permissions`,
  )
}

const createPrivacyApprovals = async ({ privacyPolicyId = '', ...data }) => {
  return await dponetAPI.post(
    `/privacy_policies/${privacyPolicyId}/privacy_policy_approvals`,
    {
      privacyPolicyApproval: data,
    },
  )
}

const listPrivacyApprovals = async ({ privacyPolicyId = '', ...params }) => {
  return await dponetAPI.get(
    `/privacy_policies/${privacyPolicyId}/privacy_policy_approvals`,
    {
      params,
    },
  )
}

const sendLink = async ({ privacyPolicyId = '', ...data }) => {
  return await dponetAPI.post(
    `/privacy_policies/${privacyPolicyId}/privacy_policy_approvals/send_link`,
    {
      sendLink: data,
    },
  )
}

const destroyPrivacyApproval = async ({
  privacyPolicyId = '',
  privacyPolicyApprovalId = '',
}) => {
  return await dponetAPI.delete(
    `/privacy_policies/${privacyPolicyId}/privacy_policy_approvals/${privacyPolicyApprovalId}`,
  )
}

const listLinkedDocuments = async ({ privacyPolicyId = '', ...params }) => {
  return await dponetAPI.get(
    `/privacy_policies/${privacyPolicyId}/evidences/linked_documents`,
    { params },
  )
}

const createLinkedDocuments = async ({ privacyPolicyId = '', evidenceIds }) => {
  return await dponetAPI.post(
    `/privacy_policies/${privacyPolicyId}/evidences/linked_documents`,
    { evidenceIds },
  )
}

const removeLinkedDocument = async ({
  privacyPolicyId = '',
  linkedDocumentId = '',
}) => {
  return await dponetAPI.delete(
    `/privacy_policies/${privacyPolicyId}/evidences/linked_documents/${linkedDocumentId}`,
  )
}

export default {
  certificate,
  create,
  createCookiePolicy,
  createLinkedDocuments,
  createPrivacyApprovals,
  destroy,
  destroyPrivacyApproval,
  exportDocument,
  get,
  getCookiePolicy,
  getPrivacyPermissions,
  listLinkedDocuments,
  listPrivacyApprovals,
  listVersions,
  put,
  removeLinkedDocument,
  updateCookiePolicy,
  updatePrivacyPermissions,
  sendLink,
}
